import './paragraph.scss';
import 'whatwg-fetch';
import merge from 'lodash/merge';

/**
 * Legacy component
 */
function Paragraph(element) {
	this.ui = {
		element: element
	};

	this.settings = merge(
		{
			apiTaskPrefix: '/assistant/task',
			id: this.ui.element.dataset.paragraphIndex,
			animationDuration: 200,
			stateClasses: {
				isExpanded: 'is-expanded'
			}
		},
		JSON.parse(this.ui.element.dataset.paragraphOptions || '{}')
	);

	this.init();
}

Paragraph.prototype.init = function () {
	this.ui.tasks = this.ui.element.querySelectorAll('[data-paragraph="task"]');

	this._handleTaskToggle();

	// Expandables
	this.triggers = this.ui.element.querySelectorAll('[data-paragraph="expandableTrigger"]');
	this.contents = this.ui.element.querySelectorAll('[data-paragraph="expandableContent"]');

	this.triggers.forEach(trigger => {
		const target = trigger.closest('.paragraph--expandable');

		trigger.setAttribute('role', 'button');
		trigger.setAttribute('tabindex', 0);

		trigger.addEventListener('click', event => {
			event.preventDefault();

			this._toggleExpandable(target);
		});

		trigger.addEventListener('keydown', event => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();

				if (event.key === 'Enter') {
					trigger.click();
				}
			}
		});

		trigger.addEventListener('keyup', event => {
			if (event.key === ' ') {
				trigger.click();
			}
		});
	});
};

Paragraph.prototype._handleTaskToggle = function () {
	var mod = this;

	function addEventListenerList(list, event, fn) {
		for (var i = 0, len = list.length; i < len; i++) {
			list[i].addEventListener(event, fn, false);
		}
	}

	addEventListenerList(this.ui.tasks, 'change', event => {
		// Generate api URL
		var apiUrlParts = [mod.settings.apiTaskPrefix];
		var taskId = event.target.id.replace(mod.settings.id + '-', '');
		let oldState = true;
		if (event.target.checked === true) {
			apiUrlParts.push('set');
			oldState = false;
		} else {
			apiUrlParts.push('unset');
			oldState = true;
		}
		apiUrlParts.push(taskId);

		// Set value to api
		return fetch(apiUrlParts.join('/'), {
			method: 'GET',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'text/html',
				'X-Requested-With': 'XMLHttpRequest'
			}
		})
			.then(response => {
				if (response.status >= 200 && response.status < 300) {
					return response.text();
				} else {
					var error = new Error(response.statusText);
					error.response = response;
					throw error;
				}
			})
			.then(() => {
				mod._setAllTogglesForId(oldState, taskId);
				mod._setAllParagraphsForId(taskId);
			})
			.catch(() => {
				mod._setAllTogglesForId(!oldState, taskId);
				// TODO show an error notification
			});
	});
};

Paragraph.prototype._setAllTogglesForId = function (state, taskId) {
	var nodeList = document.querySelectorAll('[data-paragraph-id="' + taskId + '"]');
	for (let i = 0, len = nodeList.length; i < len; i++) {
		nodeList[i].checked = !state;
		if (state) {
			nodeList[i].parentNode.classList.remove('is-checked');
		} else {
			nodeList[i].parentNode.className += ' is-checked';
		}
	}
};

Paragraph.prototype._setAllParagraphsForId = function (taskId) {
	var nodeList = document.querySelectorAll('.paragraph[data-tasks*="' + taskId + '"]');
	for (let i = 0, len = nodeList.length; i < len; i++) {
		var tasks = nodeList[i].getAttribute('data-tasks').split(',');
		let doneTasks = 0;
		tasks.forEach(id => {
			if (nodeList[i].querySelector('[data-paragraph-id="' + id + '"]').checked) {
				doneTasks += 1;
			}
		});
		var openTasks = tasks.length - doneTasks;
		var doneTasksPercentage = Math.round((doneTasks / tasks.length) * 100);
		nodeList[i].querySelector('.js-circle__content').innerHTML = openTasks;

		if (doneTasksPercentage === 100) {
			nodeList[i].classList.add('paragraph--done-tasks');
			nodeList[i].classList.remove('paragraph--open-tasks');
		} else {
			nodeList[i].classList.remove('paragraph--done-tasks');
			nodeList[i].classList.add('paragraph--open-tasks');
		}

		var circleNode = nodeList[i].querySelector('.js-circle__counter');
		circleNode.classList.forEach(className => {
			if (className.startsWith('circle__p')) {
				circleNode.classList.remove(className);
			}
		});
		circleNode.classList.add('circle__p' + doneTasksPercentage);
	}
};

Paragraph.prototype._toggleExpandable = function (target) {
	const isExpanded = target.classList.contains(this.settings.stateClasses.isExpanded);

	if (isExpanded) {
		this._hideExpandable(target);
	} else {
		this._showExpandable(target);
	}
};

Paragraph.prototype._showExpandable = function (target) {
	target.classList.add(this.settings.stateClasses.isExpanded);
};

Paragraph.prototype._hideExpandable = function (target) {
	target.classList.remove(this.settings.stateClasses.isExpanded);
};

function initParagraph(element) {
	new Paragraph(element);
}

document.querySelectorAll('[data-init~="paragraph"]').forEach(element => {
	initParagraph(element);
});

export { initParagraph };
